module.exports = __webpack_public_path__ + "img/telephone-inbound-fill.96fa980b.svg";